// extracted by mini-css-extract-plugin
export default {"eight":"JFS7P","twelve":"cRr_4","sixteen":"sKyx3","twenty":"OuZsv","twentyfour":"CqYUP","excludeFirst":"eWqKI"};